import { render, staticRenderFns } from "./VistatLogoAnimated.vue?vue&type=template&id=7671575d&scoped=true&"
import script from "./VistatLogoAnimated.vue?vue&type=script&lang=js&"
export * from "./VistatLogoAnimated.vue?vue&type=script&lang=js&"
import style0 from "./VistatLogoAnimated.vue?vue&type=style&index=0&id=7671575d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7671575d",
  null
  
)

export default component.exports